import { Component, Input } from '@angular/core';
import { InjuredPersonForm } from '../../forms/injured-person-form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-injured-person-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective
  ],
  templateUrl: './injured-person-form.component.html'
})
export class InjuredPersonFormComponent {

  @Input()
  public form: InjuredPersonForm | null = null;
}
